import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end mb-3" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent", "onClick"]

import { Idl } from '@project-serum/anchor';
import { computed, ref, toRefs } from 'vue';
import { parseAnchorType } from '@/utils';

type ParsingStatus = 'Parsed' | 'Types Expanded' | 'Raw';

export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    idl: null,
    initialStatus: { default: 'Parsed' }
  },
  setup(__props: any) {

const props = __props as { type: { name: string, type: object }, idl: Idl, initialStatus: ParsingStatus }

const statuses: ParsingStatus[] = ['Parsed', 'Types Expanded', 'Raw'];



const { type, idl, initialStatus } = toRefs(props);
const status = ref<ParsingStatus>(initialStatus.value);
const parsedType = computed(() => {
  if (status.value === 'Raw') return type.value.type;
  return parseAnchorType(type.value.type, idl.value, status.value === 'Types Expanded');
});

return (_ctx: any,_cache: any) => {
  const _component_icon_caret_down = _resolveComponent("icon-caret-down")!
  const _component_base_dropdown = _resolveComponent("base-dropdown")!
  const _component_json_explorer = _resolveComponent("json-explorer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_dropdown, {
        "menu-class": "p-3 w-40",
        placement: "bottom-end"
      }, {
        default: _withCtx(({ toggleListeners }) => [
          _createElementVNode("button", _mergeProps(_toHandlers(toggleListeners), { class: "flex items-center space-x-2 text-gray-500 hover:text-gray-900" }), [
            _createElementVNode("div", {
              class: "text-sm font-normal",
              textContent: _toDisplayString(status.value)
            }, null, 8, _hoisted_2),
            _createVNode(_component_icon_caret_down, { class: "w-5 h-5" })
          ], 16)
        ]),
        menu: _withCtx(({ close }) => [
          _createElementVNode("div", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statuses, (newStatus) => {
              return _createElementVNode("button", {
                key: newStatus,
                class: "block w-full text-left rounded-lg text-sm px-2 py-1 hover:bg-gray-100 text-gray-500 hover:text-gray-900",
                textContent: _toDisplayString(newStatus),
                onClick: ($event: any) => {status.value = newStatus; close();}
              }, null, 8, _hoisted_3)
            }), 64))
          ])
        ]),
        _: 1
      })
    ]),
    (_openBlock(), _createBlock(_component_json_explorer, {
      key: status.value,
      json: _unref(parsedType)
    }, null, 8, ["json"]))
  ]))
}
}

})